import FieldTemplate from './FieldTemplate';
export default FieldTemplate;
//# sourceMappingURL=index.js.map